import {
    Card,
    List,
    ListItem,
    ListItemPrefix,
    Accordion,
    AccordionHeader,
    AccordionBody,
} from "@material-tailwind/react";
import {
    UserCircleIcon,
    PowerIcon,
    HomeIcon,
    ChevronDownIcon,
    ChevronUpIcon
} from "@heroicons/react/24/solid";
import Link from "next/link";
import apiSlice from "@/redux/slices/apiSlice";
import { useDispatch } from "react-redux";
import { CiLocationArrow1 } from "react-icons/ci";
import { BuildingLibraryIcon, UsersIcon } from "@heroicons/react/24/solid";
import { useLogoutMutation } from "@/redux/slices/authSlice";

import { MdFeaturedPlayList } from "react-icons/md";
import { useContext, useState } from "react";
import myContext from "@/context/myContext";
import { BookText, Boxes } from "lucide-react";
import { useRouter } from "next/navigation";

export default function AdminSidebar() {
    const dispatch = useDispatch();
    const router = useRouter();
    const { updateAuthState } = useContext(myContext);
    const [logout] = useLogoutMutation();
    
    // State for dropdowns
    const [isRealEstateOpen, setIsRealEstateOpen] = useState(false);
    const [isPackersMoversOpen, setIsPackersMoversOpen] = useState(false);

    const handleLogout = async () => {
        await logout();
        updateAuthState();
        dispatch(apiSlice.util.resetApiState());
        router.push("/");
    };

    return (
        <div className="h-screen fixed w-full max-w-[16rem] p-4 rounded-none border-r border-r-purple-300 bg-purple-50">
            <div className="mb-2 p-4">
                <Link href={'/'}>
                    <div className="py-6">
                        <div className="flex justify-center mb-2">
                            <img 
                                className="w-24" 
                                src="https://cdn-icons-png.flaticon.com/128/8899/8899687.png" 
                                alt="Admin Dashboard" 
                            />
                        </div>
                        <h1 className="text-center text-xl text-black font-bold app-font">
                            Super Admin Dashboard
                        </h1>
                    </div>
                </Link>
            </div>

            <List>
                <Link href={'home'}>
                    <ListItem className="hover:bg-purple-50 active:bg-purple-100 focus:bg-purple-100 transition-colors duration-300">
                        <ListItemPrefix>
                            <HomeIcon className="h-5 w-5" />
                        </ListItemPrefix>
                        Home
                    </ListItem>
                </Link>

                {/* Real Estate Dropdown */}
                <Accordion
                    open={isRealEstateOpen}
                    icon={
                        isRealEstateOpen ? (
                            <ChevronUpIcon className="h-4 w-4" />
                        ) : (
                            <ChevronDownIcon className="h-4 w-4" />
                        )
                    }
                >
                    <ListItem 
                        className="hover:bg-purple-50 active:bg-purple-100 focus:bg-purple-100 transition-colors duration-300"
                        onClick={() => setIsRealEstateOpen(!isRealEstateOpen)}
                    >
                        <ListItemPrefix>
                            <BuildingLibraryIcon className="h-5 w-5" />
                        </ListItemPrefix>
                        Real Estate
                    </ListItem>
                    <AccordionBody className="py-1">
                        <List className="p-0">
                            <Link href={'locality'}>
                                <ListItem className="hover:bg-purple-50 active:bg-purple-100 focus:bg-purple-100 transition-colors duration-300 pl-8">
                                    <ListItemPrefix>
                                        <CiLocationArrow1 className="h-5 w-5" />
                                    </ListItemPrefix>
                                    Locality
                                </ListItem>
                            </Link>
                            
                            <Link href={'featured-projects'}>
                                <ListItem className="hover:bg-purple-50 active:bg-purple-100 focus:bg-purple-100 transition-colors duration-300 pl-8">
                                    <ListItemPrefix>
                                        <MdFeaturedPlayList className="h-5 w-5" />
                                    </ListItemPrefix>
                                    Featured Projects
                                </ListItem>
                            </Link>
                            
                            <Link href={'property'}>
                                <ListItem className="hover:bg-purple-50 active:bg-purple-100 focus:bg-purple-100 transition-colors duration-300 pl-8">
                                    <ListItemPrefix>
                                        <BuildingLibraryIcon className="h-5 w-5" />
                                    </ListItemPrefix>
                                    Properties
                                </ListItem>
                            </Link>
                        </List>
                    </AccordionBody>
                </Accordion>

                {/* Packers & Movers Dropdown */}
                <Accordion
                    open={isPackersMoversOpen}
                    icon={
                        isPackersMoversOpen ? (
                            <ChevronUpIcon className="h-4 w-4" />
                        ) : (
                            <ChevronDownIcon className="h-4 w-4" />
                        )
                    }
                >
                    <ListItem 
                        className="hover:bg-purple-50 active:bg-purple-100 focus:bg-purple-100 transition-colors duration-300"
                        onClick={() => setIsPackersMoversOpen(!isPackersMoversOpen)}
                    >
                        <ListItemPrefix>
                            <Boxes className="h-5 w-5" />
                        </ListItemPrefix>
                        Packers & Movers
                    </ListItem>
                    <AccordionBody className="py-1">
                        <List className="p-0">
                            <Link href={'item-category'}>
                                <ListItem className="hover:bg-purple-50 active:bg-purple-100 focus:bg-purple-100 transition-colors duration-300 pl-8">
                                    <ListItemPrefix>
                                        <Boxes className="h-5 w-5" />
                                    </ListItemPrefix>
                                    Item Categories
                                </ListItem>
                            </Link>
                            
                            <Link href={'items'}>
                                <ListItem className="hover:bg-purple-50 active:bg-purple-100 focus:bg-purple-100 transition-colors duration-300 pl-8">
                                    <ListItemPrefix>
                                        <Boxes className="h-5 w-5" />
                                    </ListItemPrefix>
                                    Items
                                </ListItem>
                            </Link>
                            
                            <Link href={'packer-movers-quotes'}>
                                <ListItem className="hover:bg-purple-50 active:bg-purple-100 focus:bg-purple-100 transition-colors duration-300 pl-8">
                                    <ListItemPrefix>
                                        <Boxes className="h-5 w-5" />
                                    </ListItemPrefix>
                                    Quotes
                                </ListItem>
                            </Link>
                            
                            <Link href={'packer-movers-booking'}>
                                <ListItem className="hover:bg-purple-50 active:bg-purple-100 focus:bg-purple-100 transition-colors duration-300 pl-8">
                                    <ListItemPrefix>
                                        <Boxes className="h-5 w-5" />
                                    </ListItemPrefix>
                                    Bookings
                                </ListItem>
                            </Link>
                        </List>
                    </AccordionBody>
                </Accordion>

                {/* Remaining Items */}
                <Link href={'users'}>
                    <ListItem className="hover:bg-purple-50 active:bg-purple-100 focus:bg-purple-100 transition-colors duration-300">
                        <ListItemPrefix>
                            <UsersIcon className="h-5 w-5" />
                        </ListItemPrefix>
                        Users
                    </ListItem>
                </Link>

                <Link href={'view-blogs'}>
                    <ListItem className="hover:bg-purple-50 active:bg-purple-100 focus:bg-purple-100 transition-colors duration-300">
                        <ListItemPrefix>
                            <BookText className="h-5 w-5" />
                        </ListItemPrefix>
                        View Blogs
                    </ListItem>
                </Link>

                <Link href={'profile-page'}>
                    <ListItem className="hover:bg-purple-50 active:bg-purple-100 focus:bg-purple-100 transition-colors duration-300">
                        <ListItemPrefix>
                            <UserCircleIcon className="h-5 w-5" />
                        </ListItemPrefix>
                        Profile
                    </ListItem>
                </Link>

                <ListItem
                    onClick={handleLogout} 
                    className="hover:bg-purple-50 active:bg-purple-100 focus:bg-purple-100 transition-colors duration-300"
                >
                    <ListItemPrefix>
                        <PowerIcon className="h-5 w-5" />
                    </ListItemPrefix>
                    Log Out
                </ListItem>
            </List>
        </div>
    );
}